import React from 'react';
import { Avatar, Box, Divider, BoxProps } from '@mui/material';
// CONSTANTS
import { TP_COLORS } from '../../constants';
import { useAppSelector } from '../../hooks';
import { getThemeMode } from '../../store/ConfigSlice';

export interface ILetterDivider {
  text: string;
  containerProps?: BoxProps;
}

const defaultContainerStyles: BoxProps['sx'] = {
  display: 'flex',
  alignItems: 'center',
};

const LetterDivider: React.FC<ILetterDivider> = ({ text, containerProps }) => {
  // HOOKS
  const themeMode = useAppSelector(getThemeMode);

  // RENDER
  return (
    <Box
      {...containerProps}
      sx={
        containerProps && containerProps.sx
          ? { ...defaultContainerStyles, ...containerProps.sx }
          : defaultContainerStyles
      }
    >
      <Avatar
        sx={{
          color: themeMode === 'dark' ? TP_COLORS.white : TP_COLORS.black,
          backgroundColor:
            themeMode === 'dark'
              ? TP_COLORS.paperGray.dark
              : TP_COLORS.paperGray.light,
        }}
      >
        {text.toUpperCase()}
      </Avatar>
      <Divider sx={{ width: '100%', borderBottomWidth: 'thick' }} />
    </Box>
  );
};

export default LetterDivider;
